export default "__VITE_ASSET__004a7e53__"